<template>
  <div class="seasons">
    <span id="c-add-up">
      <SeasonsAddUpdate
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :titleCard="titleCard"
        :updateData="updateData"
        :championship="championship"
      />
    </span>
    <va-card :title="$t('seasons.cards.title')">
      <template slot="actions">
        <va-button
          @click="open"
          icon="fa fa-plus"
          href="#c-add-up"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="seasons"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-popover :message="`${$t('seasons.tooltips.update')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-pencil"
              href="#c-add-up"
              @click="update(props.rowData)"
            />
          </va-popover>
          <va-popover :message="`${$t('tooltips.delete')}`" placement="bottom">
            <va-button
              flat
              color="gray"
              icon="fa fa-trash"
              @click="showModal(props.rowData)"
            />
          </va-popover>
        </template>
      </va-data-table>
    </va-card>
    <va-modal
      v-model="modalDeletar"
      size="small"
      :title="$t('modals.titleDelete')"
      :message="$t('seasons.modals.message')"
      :okText="$t('modals.confirm') "
      :cancelText="$t('modals.cancel')"
      @ok="deleting"
    />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import SeasonsAddUpdate from './SeasonsAddUpdate'

const perPage = 10
export default {
  name: 'seasons',
  props: {
    championship: {
      required: true,
    },
  },
  components: {
    SeasonsAddUpdate,
  },
  methods: {
    close (v) {
      this.showAdd = v
      this.updateData = null
    },
    update (data) {
      this.titleCard = 'update'
      this.updateData = data
      this.showAdd = true
    },
    open () {
      this.updateData = null
      this.showAdd = true
      this.titleCard = 'create'
    },
    showModal (data) {
      this.modalDeletar = true
      this.deleteId = data
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.seasons.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
          championship: this.championship,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
    deleting () {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation MyMutation($id: Int!) {
              delete_season_by_pk(id: $id) {
                id
              }
            }
          `,
          variables: {
            id: this.deleteId.id,
          },
        })
        .then(data => {
          this.$apollo.queries.pages.refetch()
          this.showMore(this.page)
          this.showToast(
            this.$t('toasts.successDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
        .catch(_ => {
          this.showToast(
            this.$t('toasts.errorDelete'),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      seasons: [],
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showAdd: false,
      modalDeletar: false,
      deleteId: 0,
      titleCard: '',
      updateData: null,
      userId: null,
    }
  },
  apollo: {
    seasons: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2, $championship: Int!) {
        seasons: season(where: {championship_id: {_eq: $championship}}, limit: $perPage, offset: $page, order_by: {id_api: desc}) {
          id
          temporada
          is_active
          order
          id_api
        }
      }
      `,
      variables () {
        return {
          perPage,
          championship: this.championship,
        }
      },
    },
    pages: {
      query: gql`
      query MyQuery($championship: Int!) {
        pages: season_aggregate(where: {championship_id: {_eq: $championship}}) {
          aggregate {
            count
          }
        }
      }
      `,
      variables () {
        return {
          championship: this.championship,
        }
      },
    },
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'temporada',
        title: this.$t('seasons.headings.temporada'),
        width: '40%',
      }, {
        name: 'id_api',
        title: this.$t('seasons.headings.id_api'),
        width: '20%',
      }, {
        name: 'is_active',
        title: this.$t('seasons.headings.is_active'),
        width: '20%',
        callback (value) {
          return value ? 'Sim' : 'Não'
        },
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
        dataClass: 'text-center',
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('seasons')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.seasons.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
